import React, { Component } from "react";
import { connect } from "react-redux";
import { FiMoreHorizontal } from "react-icons/fi";
import { Dropdown } from "react-bootstrap";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import ShiftPatternEditModal from "components/ShiftPatterns/ShiftPatternEditModal";
import { showModal, hideModal } from "actions/modalActions";
import { shiftPatternsService } from "services";
import { errorFormating } from "utils/utils";
import Avatars from "components/Avatar/Avatars";
import DataTable from "components/DataTable";
import { withTranslation } from "react-i18next";

class ShiftPatternsList extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openEditShiftPatternModal = this.openEditShiftPatternModal.bind(this);
		this.openDeleteShiftPatternModal =
			this.openDeleteShiftPatternModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getShiftPatterns = () => this.props.getShiftPatterns();
	}

	closeModal() {
		this.props.hideModal();
	}

	openEditShiftPatternModal(shift_pattern) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.assignment.editShiftPattern"),
				style: { width: '980px', maxWidth: 'calc(100vw - 32px)' },
				content: (
					<ShiftPatternEditModal
						getShiftPatterns={this.getShiftPatterns}
						shift_pattern={shift_pattern}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openDeleteShiftPatternModal(idShiftPattern) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("shiftPatterns.deleteShiftPattern"),
				style: { width: "400px" },
				message: this.props.t("shiftPatterns.deleteConfirmation"),
				deleteAction: () => this.confirmDelete(idShiftPattern),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(title, message) {
		this.props.showModal(
			{
				open: true,
				title: title,
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	cloneShiftPattern = async (idShiftPattern) => {
		const response = await shiftPatternsService.clone(idShiftPattern);
		// console.log(response);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(
				this.props.t("shiftPatterns.cloneError"),
				textError.general ||
					textError.id ||
					this.props.t("shiftPatterns.cloneErrorMsg")
			);
		} else {
			this.getShiftPatterns();
			this.closeModal();
		}
	};

	confirmDelete = async (idShiftPattern) => {
		const response = await shiftPatternsService.remove(idShiftPattern);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(
				this.props.t("shiftPatterns.deleteError"),
				textError.general || textError.id
			);
		} else {
			this.getShiftPatterns();
			this.closeModal();
		}
	};

	getEmptyRow = () => {
		return (
			<tr>
				<td colSpan="6" className="no-result">
					{this.props.t("common.noResults")}
				</td>
			</tr>
		);
	};
	getRowsMobile = () =>
		this.props.shift_patterns.map((shift_pattern) => {
			const { canEdit } = this.props;
			return (
				<tr key={shift_pattern.id}>
					<td>
						{canEdit ? (
							<button
								className="btn-transparent btn-editable"
								onClick={() => this.openEditShiftPatternModal(shift_pattern)}
							>
								{shift_pattern.name} <br />
								<span className="label-mini">{shift_pattern.description}</span>
							</button>
						) : (
							<>
								{shift_pattern.name} <br />
								<span className="label-mini">{shift_pattern.description}</span>
							</>
						)}
					</td>
					<td>
						{shift_pattern.length ||
							(shift_pattern.items ? shift_pattern.items.length : 0)}{" "}
						{this.props.t("shiftPatterns.form.days")}
					</td>
					<td>
						{shift_pattern.enabled ? (
							<span title={this.props.t("common.active")} className="estado estado-si">
								{this.props.t("common.active")}
							</span>
						) : (
							<span title={this.props.t("common.inactive")} className="estado estado-no">
								{this.props.t("common.inactive")}
							</span>
						)}
					</td>
					<td className="td-actions">
						{canEdit && (
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.openEditShiftPatternModal(shift_pattern)}
									>
										{this.props.t("common.edit")}
									</Dropdown.Item>
									<Dropdown.Item
										as="button"
										onClick={() => this.cloneShiftPattern(shift_pattern.id)}
									>
										{this.props.t("shiftPatterns.clone")}
									</Dropdown.Item>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.openDeleteShiftPatternModal(shift_pattern.id)
										}
									>
										{this.props.t("common.delete")}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						)}
					</td>
				</tr>
			);
		});

	getShiftPatternActions = (shift_pattern) => (
		<Dropdown>
			<Dropdown.Toggle variant="action">
				<FiMoreHorizontal />
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item
					as="button"
					onClick={() => this.openEditShiftPatternModal(shift_pattern)}
				>
					{this.props.t("common.edit")}
				</Dropdown.Item>
				<Dropdown.Item
					as="button"
					onClick={() => this.cloneShiftPattern(shift_pattern.id)}
				>
					{this.props.t("shiftPatterns.clone")}
				</Dropdown.Item>
				<Dropdown.Item
					as="button"
					onClick={() => this.openDeleteShiftPatternModal(shift_pattern.id)}
				>
					{this.props.t("common.delete")}
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	getDesktopColumns = () => {
		const { canEdit } = this.props;
		return [
		{
			key: "name",
			header: this.props.t("common.name"),
			render: (shift_pattern) =>
				canEdit ? (
					<button
						className="btn-transparent btn-editable"
						onClick={() => this.openEditShiftPatternModal(shift_pattern)}
					>
						{shift_pattern.name}
					</button>
				) : (
					shift_pattern.name
				),
		},
		{
			key: "description",
			header: this.props.t("common.description"),
			render: (shift_pattern) => shift_pattern.description,
		},
		{
			key: "employees",
			header: this.props.t("shiftPatterns.list.headerEmployees"),
			render: (shift_pattern) => {
				let empleados_count = this.props.t("shiftPatterns.list.noEmployees");
				let total_employees = shift_pattern.total_employees;
				let employees_avatars = shift_pattern.employees;

				if (total_employees === 1) empleados_count = this.props.t("shiftPatterns.list.employeeCount_one");
				else if (total_employees > 1)
					empleados_count = this.props.t("shiftPatterns.list.employeeCount_other", { count: total_employees });

				return (
					<div className="avatar-container">
						{total_employees > 0 && <Avatars employees={employees_avatars} />}
						{empleados_count}
					</div>
				);
			},
		},
		{
			key: "length",
			header: this.props.t("shiftPatterns.form.length"),
			render: (shift_pattern) =>
				`${shift_pattern.length || (shift_pattern.items ? shift_pattern.items.length : 0)} ${this.props.t("shiftPatterns.form.days")}`,
		},
		{
			key: "status",
			header: this.props.t("common.status"),
			align: "center",
			render: (shift_pattern) =>
				shift_pattern.enabled ? (
					<span title="Activo" className="estado estado-si">
						Activo
					</span>
				) : (
					<span title="Inactivo" className="estado estado-no">
						Inactivo
					</span>
				),
		},
	];
	};

	getRows = () =>
		this.props.shift_patterns.map((shift_pattern) => {
			const { canEdit } = this.props;
			let empleados_count = this.props.t("shiftPatterns.list.noEmployees");
			let total_employees = shift_pattern.total_employees;
			let employees_avatars = shift_pattern.employees;

			if (total_employees === 1) empleados_count = this.props.t("shiftPatterns.list.employeeCount_one");
			else if (total_employees > 1)
				empleados_count = this.props.t("shiftPatterns.list.employeeCount_other", { count: total_employees });

			return (
				<tr key={shift_pattern.id}>
					<td>
						{canEdit ? (
							<button
								className="btn-transparent btn-editable"
								onClick={() => this.openEditShiftPatternModal(shift_pattern)}
							>
								{shift_pattern.name}
							</button>
						) : (
							shift_pattern.name
						)}
					</td>
					<td>{shift_pattern.description}</td>
					<td>
						<div className="avatar-container">
							{total_employees > 0 && <Avatars employees={employees_avatars} />}
							{empleados_count}
						</div>
					</td>
					<td>
						{shift_pattern.length ||
							(shift_pattern.items ? shift_pattern.items.length : 0)}{" "}
						{this.props.t("shiftPatterns.form.days")}
					</td>
					<td>
						{shift_pattern.enabled ? (
							<span title={this.props.t("common.active")} className="estado estado-si">
								{this.props.t("common.active")}
							</span>
						) : (
							<span title={this.props.t("common.inactive")} className="estado estado-no">
								{this.props.t("common.inactive")}
							</span>
						)}
					</td>
					<td className="td-actions">
						{canEdit && this.getShiftPatternActions(shift_pattern)}
					</td>
				</tr>
			);
		});

	render() {
		const { canEdit } = this.props;

		return (
			<>
				<Mobile>
					<div className="table-mobile-container">
						<table className="table table-shift-patterns table-mobile">
							<tbody>
								{this.props.shift_patterns.length === 0
									? this.getEmptyRow()
									: this.getRowsMobile()}
							</tbody>
						</table>
					</div>
				</Mobile>

				<TabletOrDesktop>
					<DataTable
						tableClassName="table-shift-patterns table-hover"
						tableStyle={{ backgroundColor: "#ffffff" }}
						columns={this.getDesktopColumns()}
						rows={this.props.shift_patterns || []}
						rowKey={(row) => row.id}
						emptyMessage={this.props.t("common.noResults")}
						actionsColumn={
							canEdit
								? {
										render: this.getShiftPatternActions,
										className: "td-actions",
									}
								: undefined
						}
					/>
				</TabletOrDesktop>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.shiftsReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ShiftPatternsList));
